import { render, staticRenderFns } from "./BedUsageRate.vue?vue&type=template&id=16185bb4&scoped=true"
import script from "./BedUsageRate.vue?vue&type=script&lang=js"
export * from "./BedUsageRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16185bb4",
  null
  
)

export default component.exports